module.exports = __webpack_public_path__ + "static/media/secure-energy-white.5a030269.png";